export default "/_next/static/images/product-series-c7c79a150dc6d65189074da4d27895d9.svg";